import { employee } from '@/api/employees'
import { sync } from '@/api/bosync'
import { common } from '@/api/common'
import { URLs } from '@/config/index'
import store from '@/store'


const pattern = /[0-9]/
let res = null

// 임직원 상담일지 payload 정제: 백엔드에 없는 필드 제거 + 파라미터명 매핑
function sanitizeCounselPayload(payload, mode) {
    const {
        // 제거 대상 (백엔드에 없음)
        measureContent,
        commonSignature,
        confirmUserIdx,
        supervisorUserIdx,
        // 변환 대상
        counselReceiverServiceType,
        // 나머지 유지 (counselMethodCodeName 포함 — BE counsel_method_code_name 컬럼 추가됨)
        ...rest
    } = payload
    // 린트 회피용 no-op 참조
    void measureContent; void commonSignature; void confirmUserIdx
    void supervisorUserIdx
    const result = {
        ...rest,
        homeServiceTypeCode: rest.homeServiceTypeCode || counselReceiverServiceType,
    }
    // POST 시에만 staffBaseIdx → staffName 변환
    // (View에서 staffName을 세팅해 넘기는 것을 권장하지만, 안전망으로 처리)
    if (mode === 'post') {
        if (!result.staffName && rest.staffName) {
            result.staffName = rest.staffName
        }
    }
    return result
}

export const employees = {
    namespaced: true,
    state: {
        staffs: null,
        copiedStaffs: null, //임시 정렬 또는 정리된 리스트

        //권한없이 직원 타입별 조회
        staffTypeList: null,
        staffWithHome: null,
        cogStaffList: null,

        //직원의 개인권한 
        staffPermission: null,

        //직원 배상책임보험
        defaultInsurance: null,

        //직원 필터, 검색, 선택된 직원
        contractCode: null,
        state: null,
        searchWord: null,
        selected: [],

        //직원 정보보기
        staffDetail: null,
        staffCertificate: null,
        bankInfo: null,
        contract: null,
        salarySettingInfo: null,
        salaryList: null,
        // contractDocument: null,

        //memo
        staffMemo: null,
        slipStaffInfo: null,

        //직원 계약필수파일
        disabilityCrimeList: null,
        elderCrimeList: null,
        bankList: null,
        crimeList: null,
        healthList: null,
        idPictureFileList: null,
        socialworkerCertificateList: null,
        caregiverCertificateList: null,
        dementiaEduList: null,

        // nurseCertificateList,

        //수급자,시니어 담당자 선택용 리스트, 계약완료 모든직원
        staffList: null,
        staffListAll: null,

        //직원근로계약 정보(근로자)
        contractInfo: null,
        branchInfoDetail: null,
        contractInfoDetail: null,

        //직원 급여내역
        applyYear: null,
        paySlip: null,
        salaryNumberList: null,
        customerSalarySettingList: null,
        customerSalarySetting: null,

        //직원 급여대장
        payRoll: null,
        payrollList: null,

        //급여마감처리
        payslipList: null,

        // 근로계약조항
        ruleofPartTime: null,
        ruleofRegular: null,
        ruleofTemporary: null,
        ruleofFreelancer: null,

        // 휴가부여관리
        vacationAnnual: null, //상세정보
        useVacation: null,
        vacationLog: null, //휴가부여내역
        vacationStaff: null, //상세보기한 직원의 정보
        annualBasis: null, //연차부여근거 정보

        // 근로계약조회
        contractList: null,
        contractOfficeSeal: null,
        contractStaffSign: null,
        contractCeoSign: null,

        // 4대보험
        default4insurances: null,
        changed4insurances: null,

        // 4대보험 취득,상실 리스트
        insurance4List: null,

        // 월보수변경신청 리스트
        monthlyChangeReport: null,

        // 건강검진서 조회
        healthcheckups: null,

        // 급여명세서
        aPayslipDetail: null,

        // 미근로 30일이상
        noworkOver30: null,

        // 월별근로시간
        monthWorktimes: null,

        // 장기근속대상자
        longPeriodWorkingStaffs: null,

        // 출퇴근
        staffCommuteList: null,

        // 직원상태설정정보
        statusSettingEmployee: null,

        //직원 사직서 관리대장
        resignList: null,

        //직원 필수서류 목록형
        necessaryDocs: null,

        //직원대시보드
        dashboard: null,
        contractCount: null,
        eduDementiaStaffList: null,
        longtermWorkStaffList: null,
        newContract30StaffList: null,
        notWorkCount: null,
        vacationStaffList: null,
        workPlusStaffList: null,
        insure4FeeReportList: null,
        staffCarePayCosts: null,
        staffBathPayCosts: null,
        staffActive11s: null,
        staffActive12s: null,
        staffActive13s: null,
        needInsuranceList: null,

        // 퇴직적립금
        retireFunds: null,

        // 직원급여 일괄수정
        salariesList: null,

        // 임직원 상담일지
        staffCounselList: null,
        staffCounselMonthlyList: null,
        staffCounselHistory: null,
        staffCounselFiles: [],
    },
    mutations: {
        STAFF(state, payload) {
            state.staffs = payload.list
        },
        STAFF_COUNSEL_LIST(state, payload) {
            state.staffCounselList = payload.memberList || payload
        },
        RESET_STAFF_COUNSEL_LIST(state) {
            state.staffCounselList = null
        },
        STAFF_COUNSEL_MONTHLY_LIST(state, payload) {
            state.staffCounselMonthlyList = payload
        },
        RESET_STAFF_COUNSEL_MONTHLY_LIST(state) {
            state.staffCounselMonthlyList = null
        },
        STAFF_COUNSEL_HISTORY(state, payload) {
            state.staffCounselHistory = payload
        },
        STAFF_COUNSEL_FILES(state, payload) {
            state.staffCounselFiles = payload || []
        },
        RESET_EMPLOYEE(state) {
            //리스트
            state.contractCode = null
            state.state = null
            state.searchWord = null
            state.selected = []
            state.copiedStaffs = null

            // TODO: 다른페이지(수급자 -> 시니어 등) 이동 시 기존에 조회했던 상세정보를 모두 지운다.
            //직원 
            state.staffDetail = null
            state.staffCertificate = null
            state.bankInfo = null
            state.contract = null
            state.staffMemo = null
        },
        ADD_EMPLOYEE(state, payload) {
            if (!state.staffs) state.staffs = []
            state.staffs.unshift(payload.staffVO)
        },
        SET_CONTRACT_CODE(state, payload) {
            state.contractCode = payload
        },
        SET_STAFF_STATE(state, payload) {
            state.state = payload
        },
        SET_SEARCH_WORD(state, payload) {
            state.searchWord = payload
        },
        CLEAR_EMPLOYEE_SELECTED(state) {
            state.selected = []
        },
        // AUTO_CHANGE_SELECT_STAFF(state, payload) {
        //     let selections = []

        //     if(state.selected.length === 0) state.selected = []
        //     else state.selected = []

        //     state.contractCode = (payload.contract === 'all')?null:payload.contract
        //     state.state = (payload.status === 'all')?null:payload.status

        //     state.copiedStaffs.forEach(item => {
        //         if (payload.contract === '11'&&item.staffContractCode!=='33') {
        //             selections = {
        //                 userIdx: item.userIdx,
        //                 staffContractIdx: item.staffContractIdx,
        //                 staffBaseIdx: item.staffBaseIdx
        //             }
        //         } else if (payload.contractCode === '12'&&item.staffContractCode === '33') {
        //             selections = {
        //                 userIdx: item.userIdx,
        //                 staffContractIdx: item.staffContractIdx,
        //                 staffBaseIdx: item.staffBaseIdx
        //             }
        //         } else {
        //             selections = {
        //                 userIdx: item.userIdx,
        //                 staffContractIdx: item.staffContractIdx,
        //                 staffBaseIdx: item.staffBaseIdx
        //             }
        //         }

        //         state.selected.push(selections)
        //     })
        // },
        ALL_EMPLOYEE_SELECTED(state) {
            if (!state.copiedStaffs) {
                return
            }
            if (state.selected.length) {
                state.selected = []
            } else {
                state.copiedStaffs.forEach(item => {
                    state.selected.push({
                        userIdx: item.userIdx,
                        staffContractIdx: item.staffContractIdx,
                        staffBaseIdx: item.staffBaseIdx,
                        contractWorkIdx: item.contractWorkIdx
                    })
                })
            }

            return true
        },
        // CLEAR_AND_ALL_SELECTED(state, payload) {
        //     state.selected = []

        //     if (!payload.status && !payload.ccode) { 
        //         // 전체목록에서 선택
        //         state.staffs.forEach(item => {
        //             state.selected.push({
        //                 userIdx: item.userIdx,
        //                 staffContractidx: item.staffContractIdx,
        //                 staffBaseIdx: item.staffBaseIdx
        //             })
        //         })
        //     } else if (payload.status === '13' && !payload.ccode) {
        //         // 계약완료자만 선택
        //         state.staffs.forEach(item => {
        //             if (item.contractStateCode === '13') {
        //                 state.selected.push({
        //                     userIdx: item.userIdx,
        //                     staffContractidx: item.staffContractIdx,
        //                     staffBaseIdx: item.staffBaseIdx
        //                 })
        //             }
        //         })
        //     }
        // },
        ALL_SELECTED(state) {
            if (!state.copiedStaffs) {
                return
            }
            state.copiedStaffs.forEach(item => {
                state.selected.push({
                    userIdx: item.userIdx,
                    staffContractIdx: item.staffContractIdx,
                    staffBaseIdx: item.staffBaseIdx,
                    contractWorkIdx: item.contractWorkIdx

                })
            })

            return true
        },
        CONTRACT_SELECTED(state) {
            if (!state.copiedStaffs) {
                return
            }
            state.copiedStaffs.forEach(item => {
                state.selected.push({
                    userIdx: item.userIdx,
                    staffContractIdx: item.staffContractIdx,
                    staffBaseIdx: item.staffBaseIdx,
                    contractWorkIdx: item.contractWorkIdx
                })
            })

            // TODO: 상태만 변경으로 마무리하고 다음에 자동 선택되도록 기능 추가(setTimeout안쓰고 개발)
            // setTimeout(() => {   
            // state.recipients.forEach(item => {
            //     if(item.suadeContractStateCode === state.state) {
            //         state.selected.push({
            //             userIdx: item.userIdx,
            //             homeSeniorIdx: item.homeSeniorIdx,
            //             suadeContractIdx: item.suadeContractIdx,
            //             homeReceiverIdx: item.homeReceiverIdx
            //         })
            //     }
            // })
            // }, 300)

            return true
        },
        EMPLOYEE_SELECTED(state, payload) {
            console.log(payload)
            let index = state.selected.findIndex(item => item.userIdx === payload.userIdx)
            if (index === -1) {
                state.selected.push({
                    userIdx: payload.userIdx,
                    staffContractIdx: payload.staffContractIdx,
                    staffBaseIdx: payload.staffBaseIdx,
                    contractWorkIdx: payload.contractWorkIdx
                })
            } else {
                state.selected.splice(index, 1)
            }
        },
        REGIST_EMPLOYEE_IMAGE(state, payload) {
            state.staffDetail.userImagePath = payload.userImagePath
            let obj = state.staffs.filter(item => item.userIdx === payload.userIdx)
            obj[0].userImagePath = payload.userImagePath

            if (state.slipStaffInfo.userIdx === payload.userIdx)
                state.slipStaffInfo.userImagePath = payload.userImagePath
        },
        DELETE_EMPLOYEE_IMAGE(state, payload) {
            state.staffDetail.userImagePath = null
            let obj = state.staffs.filter(item => item.userIdx === payload)
            obj[0].userImagePath = null
        },
        EMPLOYEE_DETAIL_INFO(state, payload) {
            state.staffDetail = payload.staffBasicInfo
            let pre = state.staffDetail.rno3 ? atob(decodeURIComponent(state.staffDetail.rno3)) : null
            let back = state.staffDetail.rnoEnc ? atob(decodeURIComponent(state.staffDetail.rnoEnc)) : null
            state.staffDetail['rnoSum'] = pre ? pre + back : null
            state.contract = payload.staffContract

            state.bankList = payload.bankList
            state.salarySettingInfo = payload.customerSalarySetting
            state.salaryList = payload.customerSalarySettingList

            if (payload.userBankAccount) {
                state.bankInfo = payload.userBankAccount[0]
            } else {
                state.bankInfo = null
            }

            state.crimeList = payload.crimeList
            state.elderCrimeList = payload.elderCrimeList
            state.disabilityCrimeList = payload.disabilityCrimeList
            state.healthList = payload.healthList
                // replace from the of the top line to detach on vue when an array is changed
                // 파일없는사람은 오류남
                // state.healthList = []
                // state.healthList = [...payload.healthList] 
            state.idPictureFileList = payload.idPictureFileList
            state.dementiaEduList = payload.dementiaEduList

            state.socialworkerCertificateList = payload.socialworkerCertificateList
            state.caregiverCertificateList = payload.caregiverCertificateList
            state.staffCertificate = payload.staffCertificateInfo
        },
        // EMPLOYEE_BANK(state, payload) {
        //     state.bankInfo = payload.userBankAccount
        // },
        STAFF_CONTRACT_LIST(state, payload) {
            state.contractList = payload.list
        },
        // EMPLOYEE_CONTRACT_DOCUMENT(state, payload) {
        //     state.contractDocument = payload
        // },
        EMPLOYEE_MEMO(state, payload) {
            state.slipStaffInfo = payload.staffInfo
            state.staffMemo = payload.userMemoList
        },
        REGIST_EMPLOYEE_MEMO(state, payload) {
            if (state.slipStaffInfo.userIdx === payload.memo.userIdx) {
                if (!state.staffMemo) state.staffMemo = []
                state.staffMemo.unshift(payload.memo)
            }
        },
        UPDATE_EMPLOYEE_MEMO(state, payload) {
            let index = state.staffMemo.findIndex(item => item.userConsultIdx === payload.midx)
            state.staffMemo.splice(index, 1, payload.memo)
        },
        DELETE_EMPLOYEE_MEMO(state, payload) {
            let index = state.staffMemo.findIndex(item => item.userConsultIdx === payload)
            state.staffMemo.splice(index, 1)
            if (state.staffMemo.length === 0) state.staffMemo = null
        },
        DELETE_EMPLOYEE_MEMO_FILE(state, payload) {
            let files = state.staffMemo[payload.mIndex].userConsultFileList
            files.splice(payload.index, 1)
            if (!files.length) files = null
        },
        EMPLOYEE_CONTRACT_FINISH(state, payload) {
            state.contractInfo = payload
            state.applyYear = payload.applyYear
            state.branchInfoDetail = payload.branchInfo
            state.contractInfoDetail = payload.contractInfo
            state.salaryNumberList = payload.salaryNumberList
            state.customerSalarySetting = payload.customerSalarySetting
            state.ruleofPartTime = payload.rules.partTime
            state.ruleofRegular = payload.rules.regular
            state.ruleofTemporary = payload.rules.temporary
            state.ruleofFreelancer = payload.rules.freelancer

            if (state.contractInfoDetail) {
                let pre = state.contractInfoDetail.rno3 ? atob(decodeURIComponent(state.contractInfoDetail.rno3)) : null
                let back = state.contractInfoDetail.rnoEnc ? atob(decodeURIComponent(state.contractInfoDetail.rnoEnc)) : null
                state.contractInfoDetail['rnoSum'] = pre ? pre + back : null
            }

            if (payload.digitalSignatureInfo) {
                if (payload.digitalSignatureInfo.digitalSignatureFile)
                    state.contractStaffSign = payload.digitalSignatureInfo.digitalSignatureFile
                else
                    state.contractStaffSign = null
            }

            if (payload.branchInfo.officeSealFileIdx)
                state.contractOfficeSeal = payload.branchInfo.officeSealFileIdx
            else
                state.contractOfficeSeal = null

            if (payload.ceoDigitalSignatureFile)
                state.contractCeoSign = payload.ceoDigitalSignatureFile
            else
                state.contractCeoSign = null
        },
        CONTRACT_W4C_PRINT(state, payload) {
            state.contractInfo = payload
            state.applyYear = payload.applyYear
            state.branchInfoDetail = payload.branchInfo
            state.contractInfoDetail = payload.contractInfo
            state.salaryNumberList = payload.salaryNumberList
            state.customerSalarySetting = payload.customerSalarySetting

            if (payload.digitalSignatureInfo) {
                if (payload.digitalSignatureInfo.digitalSignatureFile)
                    state.contractStaffSign = payload.digitalSignatureInfo.digitalSignatureFile
                else
                    state.contractStaffSign = null
            }

            if (payload.branchInfo.officeSealFileIdx)
                state.contractOfficeSeal = payload.branchInfo.officeSealFileIdx
            else
                state.contractOfficeSeal = null

            if (payload.ceoDigitalSignatureFile)
                state.contractCeoSign = payload.ceoDigitalSignatureFile
            else
                state.contractCeoSign = null
        },
        DELETE_EMPLOYEE_CONTRACT(state, payload) {
            let findIdx

            state.contractList.forEach((item, index) => {
                let n = item.contractList.findIndex(
                    element => element.contractWorkIdx === payload.cwidx
                )

                if (n > -1) findIdx = index
            })

            state.contractList.splice(findIdx, 1)
        },
        EMPLOYEE_CONTRACT_DETAIL(state, payload) {
            state.branchInfoDetail = payload.branchInfo
                // state.detailSalaryInfo = payload.caregiverSalarySetting
            state.contractInfoDetail = payload.contractInfo
            state.contractOfficeSeal = payload.ceoDigitalSignatureFile
            state.contractStaffSign = payload.staffDigitalSignatureFile
        },
        STAFF_LIST_TYPE(state, payload) {
            state.staffTypeList = payload.list
        },
        CALENDAR_COG_STAFF(state, payload) {
            state.cogStaffList = payload.list
        },
        STAFF_LIST(state, payload) {
            state.staffList = payload.staffList
        },
        STAFF_LIST_ALL(state, payload) {
            state.staffListAll = payload.staffList
        },
        UPDATE_BANK_ACCOUNT(state, payload) {
            state.bankInfo = payload.userBankAccount[0]
        },
        UPDATE_STAFF_INFO(state, payload) {
            state.staffDetail = payload.staffBasicInfo
        },
        // REGIST_HEALTH_LIST(state, payload) {
        //     let index = state.healthcheckups.findIndex(item => item.staffBaseIdx === payload.idx)
        //     let obj = state.healthcheckups[index]
        //     obj.medicalFileList.forEach(item => {
        //         let tmp = []
        //         payload.info.uploadFile.forEach(file => {
        //             if(item.issueYear === file.submitYmd.substr(0,4)) {
        //                 item.fileNameList = file.healthList
        //                 if(item.fileNameList) {
        //                     item.fileNameList.forEach(e => {
        //                         tmp.push(item.commonAttachFileIdx)
        //                     })
        //                 }
        //                 item.submitYmd = file.submitYmd
        //             }
        //         })
        //         if(tmp.length) item.fileIdxs = `${tmp}`
        //     })
        //     state.healthcheckups[index].submitYmd = payload.ymd
        // },
        REGIST_STAFF_FILE(state, payload) {
            switch (payload.type) {
                case '11':
                    state.bankList = payload.info.uploadFile;
                    break
                case '12':
                    state.healthList = payload.info.uploadFile;
                    break
                case '13':
                    state.socialworkerCertificateList = payload.info.uploadFile;
                    break
                case '14':
                    state.caregiverCertificateList = payload.info.uploadFile;
                    break
                case '15':
                    state.idPictureFileList = payload.info.uploadFile;
                    break
                case '16':
                    state.crimeList = payload.info.uploadFile;
                    break
                case '19':
                    state.nurseCertificateList = payload.info.uploadFile;
                    break
                case '20':
                    state.disabilityCrimeList = payload.info.uploadFile;
                    break
                case '21':
                    state.elderCrimeList = payload.info.uploadFile;
                    break
                case '22':
                    state.dementiaEduList = payload.info.uploadFile;
                    break
            }
        },
        DELETE_STAFF_FILE(state, payload) {
            let index = null
            switch (payload.type) {
                case '11':
                    let ymdIndex1 = state.bankList.findIndex(item => item.submitYmd === payload.ymd)
                    let index1 = state.bankList[ymdIndex1].bankList.findIndex(item => item.commonAttachFileIdx === payload.idx)
                    let arr1 = state.bankList[ymdIndex1]
                    arr1.bankList.splice(index1, 1)
                    if (!arr1.bankList.length) state.bankList.splice(ymdIndex1, 1)
                    if (!state.bankList.length) state.bankList = null
                    break
                case '12':
                    let ymdIndex2 = state.healthList.findIndex(item => item.submitYmd === payload.ymd)
                    let index2 = state.healthList[ymdIndex2].healthList.findIndex(item => item.commonAttachFileIdx === payload.idx)
                    let arr2 = state.healthList[ymdIndex2]
                    arr2.healthList.splice(index2, 1)
                    if (!arr2.healthList.length) state.healthList.splice(ymdIndex2, 1)
                    if (!state.healthList.length) state.healthList = null
                case '13':
                    state.socialworkerCertificateList = null;
                    break
                case '14':
                    state.caregiverCertificateList = null;
                    break
                case '15':
                    state.idPictureFileList = null;
                    break
                case '16':
                    index = state.crimeList.findIndex(item => item.submitYear === payload.ymd)
                    if (index !== -1) {
                        let arr = state.crimeList[index]
                        arr.crimeList = null
                        state.crimeList.splice(index, 1)
                    }
                    if (!state.crimeList.length) state.crimeList = null;
                    break
                case '19':
                    state.nurseCertificateList = null;
                    break
                case '20':
                    index = state.disabilityCrimeList.findIndex(item => item.submitYear === payload.ymd)
                    if (index !== -1) {
                        let arr = state.disabilityCrimeList[index]
                        arr.disabilityCrimeList = null
                        state.disabilityCrimeList.splice(index, 1)
                    }
                    if (!state.disabilityCrimeList.length) state.disabilityCrimeList = null;
                    break
                case '21':
                    index = state.elderCrimeList.findIndex(item => item.submitYear === payload.ymd)
                    if (index !== -1) {
                        let arr = state.elderCrimeList[index]
                        arr.elderCrimeList = null
                        state.elderCrimeList.splice(index, 1)
                    }
                    if (!state.elderCrimeList.length) state.elderCrimeList = null;
                    break
                case '22':
                    state.dementiaEduList = null;
                    break
            }
        },
        STAFF_PAY_SLIP(state, payload) {
            state.paySlip = payload.staffPayslipList
        },
        RESET_PAY_SLIP(state) {
            state.paySlip = null
        },
        STAFF_PAY_ROLL(state, payload) {
            state.payRoll = payload.staffPayslipList
        },
        RESET_PAY_ROLL(state) {
            state.payRoll = null
        },
        STAFF_PAY_ROLL_LIST(state, payload) {
            state.payrollList = payload.staffPayslipList
        },
        STAFF_PERMISSION(state, payload) {
            state.staffPermission = payload.userPermissionList
        },
        RESET_STAFF_PERMISSION(state, payload) {
            state.staffPermission = null
        },
        STAFF_VACATION_ANNUAL(state, payload) {
            state.vacationLog = payload.vacationGrantList
            state.vacationStaff = payload.staffInfo
        },
        RESET_VACATION_ANNUAL(state, payload) {
            state.vacationAnnual = null
        },
        STAFF_USE_VACATION(state, payload) {
            state.useVacation = payload.vacationYearList
            console.log(state.useVacation)
        },
        RESET_USE_VACATION(state, payload) {
            state.useVacation = null
        },
        CHANGE_VACATION_USE(state, payload) {
            let index = state.useVacation.findIndex(item => item.staffBaseIdx === payload.idx)
            state.useVacation[index].annualUseYn = payload.yn
        },
        ANNUAL_CALC(state, payload) {
            state.useVacation = payload.vacationYearList
        },
        VACATION_GRANTS(state, payload) {
            state.useVacation = payload.vacationYearList
        },
        VACATION_GRANT(state, payload) {
            if (!state.vacationLog) state.vacationLog = []
            state.vacationLog.unshift(payload.staffVacationGrantInfo)
            let index = state.useVacation.forEach(item => item.staffBaseIdx === payload.vacationYearList.staffBaseIdx)
            state.useVacation.splice(index, 1, payload.vacationYearList)
        },
        STAFF_VACATION_TYPE(state, payload) {
            state.vacationLog = payload
            state.vacationStaff = payload
        },
        DELETE_VACATION_GRANT(state, payload) {
            let pIndex = state.useVacation.forEach(item => item.staffBaseIdx === payload.vacationYearList.staffBaseIdx)
            state.useVacation.splice(pIndex, 1, payload.vacationYearList)
            let index = state.vacationLog.findIndex(item => item.staffVacationGrantIdx === payload.idx)
            state.vacationLog.splice(index, 1)
            if (!state.vacationLog.length) state.vacationLog = null
        },
        ANNUAL_BASIS(state, payload) {
            state.annualBasis = payload.annualGrantBaseList
        },
        UPDATE_BASIC_ANNUAL(state, payload) {
            let index = state.useVacation.findIndex(item => item.staffBaseIdx === payload.vacationYearInfo.staffBaseIdx)
            state.useVacation.splice(index, 1, payload.vacationYearInfo)
        },
        GET_PAYSLIP_CLOSE(state, payload) {
            if (!payload) state.payslipList = null
            else state.payslipList = payload.payslipList
        },
        DEFAULT_FOUR_INSURANCES(state, payload) {
            state.default4insurances = payload.qualifyLossList
        },
        CHANGED_FOUR_INSURANCES(state, payload) {
            state.changed4insurances = payload.monthlyChangeList
        },
        REPORT_EMPLOYEE_PAYSLIP(state, payload) {
            state.aPayslipDetail = payload.staffPayslipDescList
        },
        GET_HEALTH_CHECKUPS(state, payload) {
            state.healthcheckups = payload.staffSubmitFileList
        },
        GET_OVER_NOWORKING_THIRTY(state, payload) {
            state.noworkOver30 = payload.list
        },
        GET_MONTHLY_WORKTIMES(state, payload) {
            state.monthWorktimes = payload.list
        },
        GET_LONG_PERIOD_WORKING_STAFFS(state, payload) {
            state.longPeriodWorkingStaffs = payload.longtermWorkStaffList
        },
        RESET_SUBMIT_FILE(state, payload) {
            state.healthcheckups = null
        },
        STAFF_COMMUTE_SCHEDULE(state, payload) {
            if (payload.rtnList) {
                let staff = payload.rtnList[0]
                state.staffCommuteList = staff[1].commuteList
            }
        },
        STATUS_EMPLOYMENT_SETTING(state, payload) {
            if (payload)
                state.statusSettingEmployee = payload.staffBaseStateList
        },
        STAFF_RESIGH_LIST(state, payload) {
            state.resignList = payload.electapDocumentList
        },
        CHANGE_ACTIVE(state, payload) {
            state.contract.activeStateCode = payload.activeStateCode
            let str = null
            switch (payload.activeStateCode) {
                case '11':
                    str = '활동중';
                    break
                case '12':
                    str = '휴직중';
                    break
                case '13':
                    str = '보류';
                    break
                case '14':
                    str = '퇴직';
                    break
            }
            state.contract.activeStateCodeName = str

            let index = state.staffs.findIndex(item => item.staffBaseIdx === payload.idx)
            if (index !== -1) {
                state.staffs[index].activeStateCode = payload.activeStateCode
                state.staffs[index].activeStateCodeName = str
            }
        },
        CHANGE_ACTIVE_ALL(state, payload) {
            let arr = payload.staffBaseIdxs.split(',')
            state.staffs.forEach(item => {
                if (arr.includes(String(item.staffBaseIdx))) {
                    item.activeStateCode = payload.activeStateCode
                    item.activeStateCodeName = payload.activeStateCode === '11' ? '활동중' : '미활동'
                }
            })
        },
        EMPLOYEE_NECESSARY_DOCS(state, payload) {
            state.necessaryDocs = payload.staffFileList
        },
        REGIST_ESS_FILE(state, payload) {
            let index = state.necessaryDocs.findIndex(item => item.staffBaseIdx === payload.idx)

            switch (payload.type) {
                case '13':
                    state.necessaryDocs[index].socialworkerFile = payload.info.uploadFile;
                    break
                case '14':
                    state.necessaryDocs[index].caregiverFile = payload.info.uploadFile;
                    break
                case '15':
                    state.necessaryDocs[index].idPictureFile = payload.info.uploadFile;
                    break
                case '16':
                    state.necessaryDocs[index].crimeList = payload.info.uploadFile;
                    break
                case '20':
                    state.necessaryDocs[index].disabilityCrimeList = payload.info.uploadFile;
                    break
                case '21':
                    state.necessaryDocs[index].elderCrimeList = payload.info.uploadFile;
                    break
                case '22':
                    state.necessaryDocs[index].dementiaEduFile = payload.info.uploadFile;
            }
        },
        RESET_ESSENTIAL_FILE_LIST(state, payload) {
            state.necessaryDocs = null
        },
        DELETE_ESSENTIAL_FILE(state, payload) {
            let index = state.necessaryDocs.findIndex(item => item.staffBaseIdx === payload.idx)

            switch (payload.type) {
                case '13':
                    state.necessaryDocs[index].socialworkerFile = null;
                    break
                case '14':
                    state.necessaryDocs[index].caregiverFile = null;
                    break
                case '15':
                    state.necessaryDocs[index].idPictureFile = null;
                    break
                case '16':
                    state.necessaryDocs[index].crimeList = null;
                    break
                case '20':
                    state.necessaryDocs[index].disabilityCrimeList = null;
                    break
                case '21':
                    state.necessaryDocs[index].elderCrimeList = null;
                    break
                case '22':
                    state.necessaryDocs[index].dementiaEduFile = null;
            }
        },
        CHANGE_STATUS_COMMUTE_MANAGE_YN(state, payload) {
            state.statusSettingEmployee[payload.index].commuteManageYn = payload.info.commuteManageYn
            state.statusSettingEmployee[payload.index].dementiaEduCompleteYn = payload.info.dementiaEduCompleteYn
            state.statusSettingEmployee[payload.index].liabilityInsuranceYn = payload.info.liabilityInsuranceYn
        },
        DASHBOARD(state, payload) {
            state.dashboard = payload.dashboard
            state.contractCount = payload.contractCount
            state.eduDementiaStaffList = payload.eduDementiaStaffList
            state.longtermWorkStaffList = payload.longtermWorkStaffList
            state.newContract30StaffList = payload.newContract30StaffList
            state.notWorkCount = payload.notWorkCount
            state.vacationStaffList = payload.vacationStaffList
            state.workPlusStaffList = payload.workPlusStaffList
            state.staffCarePayCosts = payload.staffPayCostsCare
            state.staffBathPayCosts = payload.staffPayCostsBath
            state.staffActive11s = payload.staffActiveState11List
            state.staffActive12s = payload.staffActiveState12List
            state.staffActive13s = payload.staffActiveState13List
            state.needInsuranceList = payload.needInsuranceList
        },
        DASHBOARD_PAYCOSTS(state, payload) {
            state.staffCarePayCosts = payload.staffPayCostsCare
            state.staffBathPayCosts = payload.staffPayCostsBath
        },
        DASHBOARD_4INSURE(state, payload) {
            state.insure4FeeReportList = payload.insure4FeeReportList
        },
        RETIREMENT_ALLOWANCE_YEAR(state, payload) {
            // 퇴직금 관리
            state.retireFunds = payload.retireSavingAmountList
        },
        RETIREMENT_ALLOWANCE_MONTH(state, payload) {
            // 퇴직금 관리
            state.retireFunds = payload.retireAmountMonthList
        },
        ACCRUE_RETIREMENT_ALLOWANCE(state, payload) {
            let findIdx = state.retireFunds.findIndex(element => element.staffBaseIdx === payload.staffBaseIdx)

            if (findIdx > -1) {
                state.retireFunds[findIdx].retireSavingAmount = payload.retireSavingAmount
            } else {
                return
            }
        },
        GO_TO_DELETE_AS_HIDDEN(state, payload) {
            console.log("state delete staffbaseidx", typeof payload.staffBaseIdxs, payload.staffBaseIdxs.length)
            if (payload.staffBaseIdxs && !payload.staffBaseIdxs.length) {
                let findIdx = state.staffs.findIndex(element => element.staffBaseIdx === payload.staffBaseIdxs)
                if (findIdx > -1) state.staffs.splice(findIdx, 1)
            }
        },
        EMPLOYEE_4INSURANCE(state, payload) {
            state.insurance4List = payload.staffList
        },
        RESET_4INSURANCE(state, payload) {
            state.insurance4List = null
        },
        SUBMIT_EMPLOYEE_ACQUIS(state, payload) {
            let index = state.insurance4List.findIndex(item => item.staffBaseIdx === payload.staff.staffBaseIdx)
            if (index !== -1) {
                state.insurance4List.splice(index, 1, payload.staff)
            }
        },
        SUBMIT_EMPLOYEE_LOSS(state, payload) {
            let index = state.insurance4List.findIndex(item => item.staffBaseIdx === payload.staff.staffBaseIdx)
            if (index !== -1) {
                state.insurance4List.splice(index, 1, payload.staff)
            }
        },
        MONTHLY_CHANGE_REPORT(state, payload) {
            state.monthlyChangeReport = payload.idxMonthlyChangeList
        },
        RESET_MONTHLY_REPORT(state, payload) {
            state.monthlyChangeReport = null
        },
        SUBMIT_MONTHLY_CHANGE(state, payload) {
            let index = state.monthlyChangeReport.findIndex(item => item.staffBaseIdx === payload.idxMonthlyChange.staffBaseIdx)
            if (index !== -1) {
                state.monthlyChangeReport.splice(index, 1, payload.idxMonthlyChange)
            }
        },
        A_DELETE_STAFF_PAYSLIP(state, payload) {
            if (!state.payslipList) return

            let findIdx = state.payslipList.findIndex(element => element.staffBaseIdx === payload.sbidx)

            if (findIdx > -1)
                state.payslipList.splice(findIdx, 1)
        },
        REPLACE_CLOSED_PAYSLIP_LIST(state, payload) {
            if (!payload || !state.payslipList) return

            let findIdx = state.payslipList.findIndex(element => element.staffBaseIdx === payload.staffBaseIdx)
                // 특정 index 내용 삭제 후 삽입
            if (findIdx > -1) state.payslipList.splice(findIdx, 1, payload)
        },
        RESET_SELECTION_IDXS(state, payload) {
            if (payload === 'RETIRE_YEAR' || payload === 'RETIRE_MONTH') state.retireFunds = null
            else if (payload === 'CLOSE_PAYSLIP') state.payslipList = null
        },
    },
    actions: {
        // @Description 계약 완료 상태 변경과 전체선택
        // async ALL_SELECTED_CONTRACTING({commit}, payload) {
        //     commit('SET_STAFF_STATE', payload.status)
        //     commit('SET_CONTRACT_CODE', payload.ccode)

        //     commit('CLEAR_EMPLOYEE_SELECTED')

        //     if (payload.selection === 'all') commit('CLEAR_AND_ALL_SELECTED', payload)
        // },
        ALL_SELECTED({ commit, state }, payload) {
            commit('ALL_SELECTED')
                // return new Promise((resolve, reject) => {
                //     if (state.selected.length > 0) {
                //         setTimeout(() => {
                //             console.log("exec all selected by once on dispatch", state.selected.length)
                //             resolve()
                //         }, 1000)
                //     } else {
                //         console.log("Error", Error('no using'))
                //         reject(Error('no using'));
                //     }
                // })
        },
        ALL_SELECTED_RECEVING({ commit, state }, payload) {
            commit('CONTRACT_SELECTED', payload)

            // return new Promise((resolve, reject) => {
            //     if (state.selected.length > 0) {
            //         setTimeout(() => {
            //             console.log("exec all selected by once on dispatch", state.selected.length)
            //             resolve()
            //         }, 1000)
            //     } else {
            //         console.log("Error", Error('no using'))
            //         reject(Error('no using'));
            //     }
            // })
        },
        // @Description 직원조회
        async STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffs(payload)
                console.log('STAFF info', res)
                if (res.data.status === 200) {
                    commit('STAFF', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF error', error)
            }
        },
        // @Description 근로계약직원 검색
        async SEARCH_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.employee(payload)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                console.log('SEARCH_STAFF info', res)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SEARCH_STAFF error', error)
            }
        },
        // @Description 직원 근로계약 조회
        async A_CONTRACT_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.contract(payload)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                console.log('A_CONTRACT_DETAIL info', res)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('A_CONTRACT_DETAIL error', error)
            }
        },
        // @Description 직원 근로계약 상세보기 : not be used
        async EMPLOYEE_CONTRACT_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.contractInfo(payload)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('EMPLOYEE_CONTRACT_DETAIL', res.data.data)
                }
                console.log('EMPLOYEE_CONTRACT_DETAIL info', res)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_CONTRACT_DETAIL error', error)
            }
        },
        // @Description 직원 근로계약 취소하기
        async DELETE_EMPLOYEE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.contractCancel(payload)
                if (res.data.status !== 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                console.log('DELETE_EMPLOYEE_CONTRACT info', res)
                commit('DELETE_EMPLOYEE_CONTRACT', payload)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_EMPLOYEE_CONTRACT error', error)
            }
        },
        // @Description 직원 근로계약 강제 삭제하기
        async DELETE_FORCE_CONTRACTS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.staffContractDel(payload)
                if (res.data.status !== 201)   
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                else
                store.commit('OPEN_SYSTEM_BAR', { message: `${res.data.message} 최초 근로계약서는 삭제할 수 없습니다.`, color: 'success' })
                console.log('DELETE_FORCE_CONTRACTS info', res)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_FORCE_CONTRACTS err: ', error)
            }
        },
        // @Description 직원 근로계약 최초 등록
        async EMPLOYEE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.contractReg(payload)
                console.log('EMPLOYEE_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('ADD_EMPLOYEE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_CONTRACT error', error)
            }
        },
        // @Description 직원 근로계약 계약완료 전 수정
        async UPDATE_EMPLOYEE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.contractMod(payload)
                console.log('UPDATE_EMPLOYEE_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                        // commit('ADD_EMPLOYEE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_EMPLOYEE_CONTRACT error', error)
            }
        },
        // @Description 직원 연봉재계약
        async RENEW_EMPLOYEE_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.contractChange(payload)
                console.log('RENEW_EMPLOYEE_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                        // commit('ADD_EMPLOYEE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RENEW_EMPLOYEE_CONTRACT error', error)
            }
        },
        // @Description 직원 프로필이미지 등록
        async REGIST_EMPLOYEE_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.profileFile(payload)
                console.log('REGIST_EMPLOYEE_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_EMPLOYEE_IMAGE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_EMPLOYEE_IMAGE error', error)
            }
        },
        // @Description 직원 프로필이미지 삭제
        async DELETE_EMPLOYEE_IMAGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.delete.fileUpload(payload)
                console.log('DELETE_EMPLOYEE_IMAGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_EMPLOYEE_IMAGE', payload.idx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_EMPLOYEE_IMAGE error', error)
            }
        },
        // @Description 직원 상세정보 조회
        async EMPLOYEE_DETAIL_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.detailInfo(payload)
                console.log('EMPLOYEE_DETAIL_INFO info', res)
                if (res.data.status === 200) {
                    commit('EMPLOYEE_DETAIL_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_DETAIL_INFO error', error)
            }
        },
        // @Description 직원 은행정보 조회
        // async EMPLOYEE_BANK({commit}, payload) {
        //     try {
        //         store.commit('OPEN_LOADING')
        //         res = await employee.get.bankAccount(payload)
        //         console.log('EMPLOYEE_BANK info', res)
        //         if(res.data.status === 200) {
        //             commit('EMPLOYEE_BANK', res.data.data)
        //         } else {
        //             store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
        //         }
        //         store.commit('CLOSE_LOADING')
        //     } catch(error) {
        //         store.commit('CLOSE_LOADING')
        //         console.error('EMPLOYEE_BANK error', error)
        //     }
        // },
        // @Description 직원 근로계약 리스트 조회
        async STAFF_CONTRACT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                    // res = await employee.get.work(payload)
                res = await employee.get.staffContractList(payload)
                console.log('STAFF_CONTRACT_LIST info', res)
                if (res.data.status === 200) {
                    commit('STAFF_CONTRACT_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_CONTRACT_LIST error', error)
            }
        },
        // @Description 직원 필수파일 조회
        // async EMPLOYEE_CONTRACT_DOCUMENT({commit}, payload) {
        //     try {
        //         store.commit('OPEN_LOADING')
        //         res = await employee.get.contractFile(payload)
        //         console.log('EMPLOYEE_CONTRACT_DOCUMENT info', res)
        //         if(res.data.status === 200) {
        //             commit('EMPLOYEE_CONTRACT_DOCUMENT', res.data.data)
        //         } else {
        //             store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
        //         }
        //         store.commit('CLOSE_LOADING')
        //     } catch(error) {
        //         store.commit('CLOSE_LOADING')
        //         console.error('EMPLOYEE_CONTRACT_DOCUMENT error', error)
        //     }
        // },
        // @Description 직원 메모 조회
        async EMPLOYEE_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.memo(payload)
                console.log('EMPLOYEE_MEMO info', res)
                if (res.data.status === 200) {
                    commit('EMPLOYEE_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_MEMO error', error)
            }
        },
        // @Description 직원 메모 등록
        async REGIST_EMPLOYEE_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.memo(payload)
                console.log('REGIST_EMPLOYEE_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_EMPLOYEE_MEMO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_EMPLOYEE_MEMO error', error)
            }
        },
        // @Description 직원 메모 수정
        async UPDATE_EMPLOYEE_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.updateMemo(payload)
                console.log('UPDATE_EMPLOYEE_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_EMPLOYEE_MEMO', {
                        midx: payload.midx,
                        memo: res.data.data.memo
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_EMPLOYEE_MEMO error', error)
            }
        },
        // @Description 직원 메모 삭제
        async DELETE_EMPLOYEE_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.delete.memo(payload)
                console.log('DELETE_EMPLOYEE_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_EMPLOYEE_MEMO', payload.midx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_EMPLOYEE_MEMO error', error)
            }
        },
        // @Description 시니어 첨부파일 삭제
        async DELETE_EMPLOYEE_MEMO_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_EMPLOYEE_MEMO_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_EMPLOYEE_MEMO_FILE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_EMPLOYEE_MEMO_FILE error', error)
            }
        },
        // @Description 직원계약완료 조회(근로자)
        async EMPLOYEE_CONTRACT_FINISH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.contractFinish(payload)
                console.log('EMPLOYEE_CONTRACT_FINISH info', res)
                if (res.data.status === 200) {
                    commit('EMPLOYEE_CONTRACT_FINISH', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        inset: false
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_CONTRACT_FINISH error', error)
            }
        },
        // @Description 직원근로계약 완료(근로자)
        async EMPLOYEE_CONTRACT_CONFIRM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.contractConfirm(payload)
                console.log('EMPLOYEE_CONTRACT_CONFIRM info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success', inset: false })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error', inset: false })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_CONTRACT_CONFIRM error', error)
            }
        },
        // @Description 직원리스트 조회(시니어, 수급자 담당직원 선택용 리스트)
        async STAFF_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffList(payload)
                console.log('STAFF_LIST info', res)
                if (res.data.status === 200) {
                    commit('STAFF_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_LIST error', error)
            }
        },
        // @Description 직원리스트 조회(모든직원, 선택용 리스트)
        async STAFF_LIST_ALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffListAll(payload)
                console.log('STAFF_LIST_ALL info', res)
                if (res.data.status === 200) {
                    commit('STAFF_LIST_ALL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_LIST_ALL error', error)
            }
        },
        // @Description 직원 타입별 조회(권한없이 타입별 조회)
        async STAFF_LIST_TYPE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCheck(payload)
                console.log('STAFF_LIST_TYPE info', res)
                if (res.data.status === 200) {
                    commit('STAFF_LIST_TYPE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_LIST_TYPE error', error)
            }
        },
        // @Description 캘린더 인지사회복지사 조회(권한없이 타입별 조회)
        async CALENDAR_COG_STAFF({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCheck(payload)
                console.log('CALENDAR_COG_STAFF info', res)
                if (res.data.status === 200) {
                    commit('CALENDAR_COG_STAFF', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CALENDAR_COG_STAFF error', error)
            }
        },
        // @Description 직원의 계좌정보 수정
        async UPDATE_BANK_ACCOUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.bankAccount(payload)
                console.log('UPDATE_BANK_ACCOUNT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_BANK_ACCOUNT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BANK_ACCOUNT error', error)
            }
        },
        // @Description 직원정보 수정
        async UPDATE_STAFF_INFO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.detailInfo(payload)
                console.log('UPDATE_STAFF_INFO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_STAFF_INFO', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_STAFF_INFO error', error)
            }
        },
        // @Description 직원 계약서류 등록
        async REGIST_STAFF_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.fileUpload(payload)
                console.log('REGIST_STAFF_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    if (payload.type && payload.type === 'list') {
                        // commit('REGIST_HEALTH_LIST', { info: res.data.data, idx: payload.idx, ymd: payload.submitYmd })
                    } else {
                        commit('REGIST_STAFF_FILE', { type: payload.staffSubmitTypeCode, info: res.data.data })
                    }
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_STAFF_FILE error', error)
            }
        },
        // @Description 직원 계약서류 등록 (필수접수서류 현황조회)
        async REGIST_ESS_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.fileUpload(payload)
                console.log('REGIST_ESS_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_ESS_FILE', { type: payload.staffSubmitTypeCode, info: res.data.data, idx: payload.idx })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ESS_FILE error', error)
            }
        },
        // @Description 직원 계약서류 일괄업로드(범죄기록조회 3개)
        async REGIST_ESS_FILE_ALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.fileUploadList(payload)
                console.log('REGIST_ESS_FILE_ALL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_ESS_FILE_ALL error', error)
            }
        },
        // @Description 직원 계약서류 삭제 (필수접수서류 삭제)
        async DELETE_ESSENTIAL_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_ESSENTIAL_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_ESSENTIAL_FILE', { type: payload.staffSubmitTypeCode, idx: payload.sbidx })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_ESSENTIAL_FILE error', error)
            }
        },
        // 2026-04-24 [legal-edu-perf-name] 법정의무교육 전용 삭제 액션
        // @Description 법정의무교육 수료증 삭제 — 기존 DELETE_ESSENTIAL_FILE 은
        // necessaryDocs state 기반 mutation 을 commit 하여 법정의무교육관리 매트릭스 화면에서는
        // state 불일치(null)로 TypeError 발생. 본 액션은 API 호출만 수행하고 mutation 은 건드리지 않음.
        // 400/500 에러는 OPEN_SYSTEM_BAR 로 표시하고 status 값을 포함해 반환한다.
        async DELETE_LEGAL_EDU_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : '삭제 실패 (이미 삭제된 파일이거나 서버 오류)'
                store.commit('OPEN_SYSTEM_BAR', { message: msg, color: 'error' })
                console.error('DELETE_LEGAL_EDU_FILE error', error)
                return { status: (error && error.response && error.response.status) || 500, message: msg }
            }
        },
        // @Description 직원 계약서류 요청 (필수접수서류 요청)
        async REQUIRE_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.requireFile(payload)
                console.log('REQUIRE_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REQUIRE_FILE error', error)
            }
        },
        // @Description 직원 계약서류 삭제
        async DELETE_STAFF_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_STAFF_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_STAFF_FILE', { type: payload.type, idx: payload.fileIdx, ymd: payload.ymd })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_STAFF_FILE error', error)
            }
        },
        // @Description 직원 급여내역 조회
        async STAFF_PAY_SLIP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payslip(payload)
                console.log('STAFF_PAY_SLIP info', res)
                if (res.data.status === 200) {
                    commit('STAFF_PAY_SLIP', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_PAY_SLIP error', error)
            }
        },
        // @Description 직원 급여대장 조회
        async STAFF_PAY_ROLL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payroll(payload)
                console.log('STAFF_PAY_ROLL info', res)
                if (res.data.status === 200) {
                    commit('STAFF_PAY_ROLL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_PAY_ROLL error', error)
            }
        },
        // @Description 직원 급여대장 목록형
        async STAFF_PAY_ROLL_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payroll(payload)
                console.log('STAFF_PAY_ROLL_LIST info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {
                    commit('STAFF_PAY_ROLL_LIST', res.data.data)
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_PAY_ROLL_LIST error', error)
            }
        },
        // @Description 직원 급여대장 엑셀다운(전체, 상근직, 비상근직)
        async EXCEL_PAY_ROLL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payroll(payload)
                console.log('EXCEL_PAY_ROLL info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                } else {

                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EXCEL_PAY_ROLL error', error)
            }
        },
        // @Description 개인권한 조회
        async STAFF_PERMISSION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.usersPermission(payload)
                console.log('STAFF_PERMISSION info', res)
                if (res.data.status === 200) {
                    commit('STAFF_PERMISSION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_PERMISSION error', error)
            }
        },
        // @Description 개인권한 저장
        async REGIST_STAFF_PERMISSION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.usersPermission(payload)
                console.log('REGIST_STAFF_PERMISSION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_STAFF_PERMISSION error', error)
            }
        },
        // @Description 재직(경력)증명서 조회
        async STAFF_EMPLOYMENT_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.printCertificate(payload)
                console.log('STAFF_EMPLOYMENT_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_EMPLOYMENT_PRINT error', error)
            }
        },
        // @Description 직원의 급여일정 조회(캘린더)
        async STAFF_OFFER_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.offerSchedule(payload)
                console.log('STAFF_OFFER_SCHEDULE info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_OFFER_SCHEDULE', error)
            }
        },
        // @Description 직원 사원증 조회
        async STAFF_ID({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.workInfo(payload)
                console.log('STAFF_ID info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_ID', error)
            }
        },
        // @Description 취득신고서 조회
        async STAFF_ACQUIS_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.acquisPrint(payload)
                console.log('STAFF_ACQUIS_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_ACQUIS_PRINT', error)
            }
        },
        // @Description 상실신고서 조회
        async STAFF_LOSS_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.lossPrint(payload)
                console.log('STAFF_LOSS_PRINT info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_LOSS_PRINT', error)
            }
        },
        // @Description 직원 휴가부여내역 조회
        async STAFF_VACATION_ANNUAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.vacationGrant(payload)
                console.log('STAFF_VACATION_ANNUAL info', res)
                if (res.data.status === 200) {
                    commit('STAFF_VACATION_ANNUAL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_VACATION_ANNUAL', error)
            }
        },
        // @Description 직원 휴가분류별 내역 조회
        async STAFF_VACATION_TYPE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.vacationGrantType(payload)
                console.log('STAFF_VACATION_TYPE info', res)
                if (res.data.status === 200) {
                    commit('STAFF_VACATION_TYPE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_VACATION_TYPE', error)
            }
        },
        // @Description 직원 휴가사용현황 조회
        async STAFF_USE_VACATION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.useVacation(payload)
                console.log('STAFF_USE_VACATION info', res)
                if (res.data.status === 200) {
                    commit('STAFF_USE_VACATION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_USE_VACATION', error)
            }
        },
        // @Description 직원 기본연차 일괄계산
        async ANNUAL_CALC({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.basicAnnualCalc(payload)
                console.log('ANNUAL_CALC info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('ANNUAL_CALC', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ANNUAL_CALC', error)
            }
        },
        // @Description 직원 기본연차 변경
        async UPDATE_BASIC_ANNUAL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.basicAnnual(payload)
                console.log('UPDATE_BASIC_ANNUAL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('UPDATE_BASIC_ANNUAL', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BASIC_ANNUAL', error)
            }
        },
        // @Description 직원 휴가부여(일괄)
        async VACATION_GRANT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.vacationGrant(payload)
                console.log('VACATION_GRANT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('VACATION_GRANT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('VACATION_GRANT', error)
            }
        },
        // @Description 직원 휴가부여(일괄)
        async VACATION_GRANTS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.vacationGrants(payload)
                console.log('VACATION_GRANTS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('VACATION_GRANTS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('VACATION_GRANTS', error)
            }
        },
        // @Description 직원 휴가부여 삭제
        async DELETE_VACATION_GRANT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.delete.vacationGrant(payload)
                console.log('DELETE_VACATION_GRANT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_VACATION_GRANT', {
                        vacationYearList: res.data.data.vacationYearList,
                        idx: payload.idx
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_VACATION_GRANT', error)
            }
        },
        // @Description 연차사용여부 변경
        async CHANGE_VACATION_USE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.vacationUse(payload)
                console.log('CHANGE_VACATION_USE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('CHANGE_VACATION_USE', {
                        idx: payload.idx,
                        yn: payload.annualUseYn
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_VACATION_USE', error)
            }
        },
        // @Description 직원의 연차부여근거 조회
        async ANNUAL_BASIS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.annualBasis(payload)
                console.log('ANNUAL_BASIS info', res)
                if (res.data.status === 200) {
                    commit('ANNUAL_BASIS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ANNUAL_BASIS', error)
            }
        },
        // @Description 급여마감처리를 위한 조회
        async GET_PAYSLIP_CLOSE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                commit('GET_PAYSLIP_CLOSE', null)
                res = await employee.get.payslipClose(payload)
                console.log('GET_PAYSLIP_CLOSE info', res)
                if (res.data.status === 200) {
                    commit('GET_PAYSLIP_CLOSE', res.data.data)
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: 'mdi-cash-check'
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_PAYSLIP_CLOSE', error)
            }
        },
        // @Description 직원급여마감처리 하기
        async DONE_PAYSLIP_CLOSE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.payslipClose(payload)
                console.log('DONE_PAYSLIP_CLOSE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: '',
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DONE_PAYSLIP_CLOSE', error)
            }
        },
        // @Description 직원4대보험 취득상실 조회
        async DEFAULT_FOUR_INSURANCES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.insur4QualReport(payload)
                console.log('DEFAULT_FOUR_INSURANCES info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: '',
                    })

                    commit('DEFAULT_FOUR_INSURANCES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DEFAULT_FOUR_INSURANCES', error)
            }
        },
        // @Description 직원4대보험 월보수변경 조회
        async CHANGED_FOUR_INSURANCES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.monthlyChangeReport(payload)
                console.log('CHANGED_FOUR_INSURANCES info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: '',
                    })

                    commit('CHANGED_FOUR_INSURANCES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGED_FOUR_INSURANCES', error)
            }
        },
        async REPORT_EMPLOYEE_PAYSLIP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payslipDetail(payload)
                console.log('REPORT_EMPLOYEE_PAYSLIP info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: '',
                    })
                    commit('REPORT_EMPLOYEE_PAYSLIP', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REPORT_EMPLOYEE_PAYSLIP', error)
            }
        },
        // @Description 직원 건강검진조회
        async GET_HEALTH_CHECKUPS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.submitFileList(payload)
                console.log('GET_HEALTH_CHECKUPS info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', {
                    //     message: res.data.message, color: 'success',icon: '',
                    // })
                    commit('GET_HEALTH_CHECKUPS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_HEALTH_CHECKUPS', error)
            }
        },
        // @Description 직원 30일이상 미근로자 조회
        async GET_OVER_NOWORKING_THIRTY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.noWorkOver30(payload)
                console.log('GET_OVER_NOWORKING_THIRTY info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: '',
                    })
                    commit('GET_OVER_NOWORKING_THIRTY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_OVER_NOWORKING_THIRTY', error)
            }
        },
        // @Descripiton 월별근무시간
        async GET_MONTHLY_WORKTIMES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.monthWorktime(payload)
                console.log('GET_MONTHLY_WORKTIMES info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: '',
                    })
                    commit('GET_MONTHLY_WORKTIMES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_MONTHLY_WORKTIMES', error)
            }
        },
        // @Descripiton 장기근속장려금 대상자
        async GET_LONG_PERIOD_WORKING_STAFFS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.longtermWork(payload)
                console.log('GET_LONG_PERIOD_WORKING_STAFFS info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'success',
                        icon: '',
                    })
                    commit('GET_LONG_PERIOD_WORKING_STAFFS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', {
                        message: res.data.message,
                        color: 'error',
                        icon: 'error'
                    })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_LONG_PERIOD_WORKING_STAFFS', error)
            }
        },
        // // @Descripition 직원 근로계약조회
        // async STAFF_CONTRACT_LIST({commit}, payload) {
        //     try {
        //         store.commit('OPEN_LOADING')
        //         res = await employee.get.staffContractList(payload)
        //         console.log('STAFF_CONTRACT_LIST info', res)
        //         if(res.data.status === 200) {
        //             commit('STAFF_CONTRACT_LIST', res.data.data)
        //         } else {
        //             store.commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
        //         }
        //         store.commit('CLOSE_LOADING')
        //         return res.data
        //     } catch(error) {
        //         store.commit('CLOSE_LOADING')
        //         console.error('STAFF_CONTRACT_LIST', error)
        //     }
        // },
        // @Description 직원의 급여일정 조회(캘린더)
        async STAFF_OFFER_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.offerSchedule(payload)
                console.log('STAFF_OFFER_SCHEDULE info', res)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_OFFER_SCHEDULE', error)
            }
        },
        // @Description 직원의 근태관리 조회(캘린더)
        async STAFF_COMMUTE_SCHEDULE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCommuteList(payload)
                console.log('STAFF_COMMUTE_SCHEDULE info', res)
                if (res.data.status === 200) {
                    commit('STAFF_COMMUTE_SCHEDULE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COMMUTE_SCHEDULE', error)
            }
        },
        // @Description 치매교육이수확인
        async GRADE_5_RECOGS_EDU_YN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.grade5Recog(payload)
                console.log('GRADE_5_RECOGS_EDU_YN info', res)
                if (res.data.status === 201) {
                    // commit('GRADE_5_RECOGS_EDU_YN', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GRADE_5_RECOGS_EDU_YN', error)
            }
        },
        // @Description 직원등록상태정보
        async STATUS_EMPLOYMENT_SETTING({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.stateSetting(payload)
                console.log('STATUS_EMPLOYMENT_SETTING info', res)
                if (res.data.status === 200) {
                    commit('STATUS_EMPLOYMENT_SETTING', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STATUS_EMPLOYMENT_SETTING', error)
            }
        },
        // @Description 직원상태등록
        async CHANGE_STATUS_COMMUTE_MANAGE_YN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.stateSetting(payload)
                console.log('CHANGE_STATUS_COMMUTE_MANAGE_YN info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('CHANGE_STATUS_COMMUTE_MANAGE_YN', {
                        index: payload.index,
                        info: res.data.data.staffBaseStateInfo
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_STATUS_COMMUTE_MANAGE_YN', error)
            }
        },
        // @Description 직원 사직서 관리 대장
        async STAFF_RESIGH_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.resignList(payload)
                console.log('STAFF_RESIGH_LIST info', res)
                if (res.data.status === 200) {
                    commit('STAFF_RESIGH_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_RESIGH_LIST', error)
            }
        },
        // @Description 직원대시보드
        async DASHBOARD({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.dash(payload)
                console.log('DASHBOARD info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DASHBOARD', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD', error)
            }
        },
        // @Description 직원 대시보드 종사자급여지급현황
        async DASHBOARD_PAYCOSTS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.dashPayCosts(payload)
                console.log('DASHBOARD_PAYCOSTS info', res)
                if (res.data.status === 200) {
                    commit('DASHBOARD_PAYCOSTS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD_PAYCOSTS', error)
            }
        },
        // @Description 직원 대시보드 4대보험 신고현황
        async DASHBOARD_4INSURE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.dashInsure4(payload)
                console.log('DASHBOARD_4INSURE info', res)
                if (res.data.status === 200) {
                    commit('DASHBOARD_4INSURE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DASHBOARD_4INSURE', error)
            }
        },
        // @Description 직원 활동상태 변경(일괄 변경)
        async CHANGE_ACTIVE_ALL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.activeAll(payload)
                console.log('CHANGE_ACTIVE_ALL info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('CHANGE_ACTIVE_ALL', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_ACTIVE_ALL', error)
            }
        },
        // @Description 직원 활동상태 변경
        async CHANGE_ACTIVE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.active(payload)
                console.log('CHANGE_ACTIVE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('CHANGE_ACTIVE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_ACTIVE', error)
            }
        },
        // @Description 직원 필수서류 목록형 조회(종사자당 한개파일)
        async EMPLOYEE_NECESSARY_DOCS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.essentialFileList(payload)
                console.log('EMPLOYEE_NECESSARY_DOCS info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('EMPLOYEE_NECESSARY_DOCS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_NECESSARY_DOCS', error)
            }
        },
        // @Description 직원 필수서류 목록형 조회(종사자 매년 등록)
        async EMPLOYEE_NECESSARY_CRIME({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.essentialFileYear(payload)
                console.log('EMPLOYEE_NECESSARY_CRIME info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('EMPLOYEE_NECESSARY_DOCS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_NECESSARY_CRIME', error)
            }
        },
        // @Description 직원 정산내역조회 시 급여상세 조회
        async DETAIL_COUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payslipDetailCount(payload)
                console.log('DETAIL_COUNT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DETAIL_COUNT', error)
            }
        },
        // @Description 직원 강제퇴사처리
        async RESIGN_FORCED({}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.resignForced(payload)
                console.log('RESIGN_FORCED info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    //commit('RESIGN_FORCED', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RESIGN_FORCED', error)
            }
        },
        // @Desciption 종사자 제공 수급자 정보
        async STAFF_PERSON_IN_CHARGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.recipients(payload)
                console.log('STAFF_PERSON_IN_CHARGE info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_PERSON_IN_CHARGE', error)
            }
        },
        // @Description 년간퇴직적립금 조회하기
        async RETIREMENT_ALLOWANCE_YEAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.retireAmountYear(payload)
                console.log('RETIREMENT_ALLOWANCE_YEAR info', res)
                if (res.data.status === 200) {
                    commit('RETIREMENT_ALLOWANCE_YEAR', res.data.data)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RETIREMENT_ALLOWANCE_YEAR error', error)
            }
        },
        // @Description 매월퇴직적립금 조회하기
        async RETIREMENT_ALLOWANCE_MONTH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.retireAmountMonth(payload)
                console.log('RETIREMENT_ALLOWANCE_MONTH info', res)
                if (res.data.status === 200) {
                    commit('RETIREMENT_ALLOWANCE_MONTH', res.data.data)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RETIREMENT_ALLOWANCE_MONTH error', error)
            }
        },
        // @Description 매월퇴직적립금 누적하기 (one by one)
        async ACCRUE_RETIREMENT_ALLOWANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.retireAmount(payload)
                console.log('ACCRUE_RETIREMENT_ALLOWANCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('ACCRUE_RETIREMENT_ALLOWANCE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ACCRUE_RETIREMENT_ALLOWANCE', error)
            }
        },
        // @Description 매월퇴직적립금 누적하기 (일괄 - 다중)
        async ACCRUE_RETIREMENT_ALLOWANCE_ONCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.retireAmountAll(payload)
                console.log('ACCRUE_RETIREMENT_ALLOWANCE_ONCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ACCRUE_RETIREMENT_ALLOWANCE_ONCE', error)
            }
        },
        // @Description 종사자 삭제 처리 (숨김처리)
        async GO_TO_DELETE_AS_HIDDEN({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.hidden(payload)
                console.log('GO_TO_DELETE_AS_HIDDEN info', res)
                if (res.data.status === 201) {
                    commit('GO_TO_DELETE_AS_HIDDEN', payload)
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GO_TO_DELETE_AS_HIDDEN', error)
            }
        },
        // @Description 종사자 W4C신고용 프린트
        async CONTRACT_W4C_PRINT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.contractFinishW4C(payload)
                console.log('CONTRACT_W4C_PRINT info', res)
                if (res.data.status === 200) {
                    commit('CONTRACT_W4C_PRINT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CONTRACT_W4C_PRINT', error)
            }
        },
        // @Description 종사자 4대보험 취득,상실 리스트
        async EMPLOYEE_4INSURANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.insurance4List(payload)
                console.log('EMPLOYEE_4INSURANCE info', res)
                if (res.data.status === 200) {
                    commit('EMPLOYEE_4INSURANCE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_4INSURANCE', error)
            }
        },
        // @Description 종사자 4대보험 취득정보 기본정보 조회
        async EMPLOYEE_ACQUIS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.qualifyAcquis(payload)
                console.log('EMPLOYEE_ACQUIS info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_ACQUIS', error)
            }
        },
        // @Description 조사자 4대보험 취득요청,저장
        async SUBMIT_EMPLOYEE_ACQUIS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.qualifyAcquis(payload)
                console.log('SUBMIT_EMPLOYEE_ACQUIS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SUBMIT_EMPLOYEE_ACQUIS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SUBMIT_EMPLOYEE_ACQUIS', error)
            }
        },
        // @Description 종사자 4대보험 상실정보 기본정보 조회
        async EMPLOYEE_LOSS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.qualifyLoss(payload)
                console.log('EMPLOYEE_LOSS info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_LOSS', error)
            }
        },
        // @Description 종사자 4대보험 상실정보 보수총액 조회
        async EMPLOYEE_LOSS_PAYROLL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.qualLossPay(payload)
                console.log('EMPLOYEE_LOSS_PAYROLL info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EMPLOYEE_LOSS_PAYROLL', error)
            }
        },
        // @Description 조사자 4대보험 상실요청,저장
        async SUBMIT_EMPLOYEE_LOSS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.qualifyLoss(payload)
                console.log('SUBMIT_EMPLOYEE_LOSS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SUBMIT_EMPLOYEE_LOSS', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SUBMIT_EMPLOYEE_LOSS', error)
            }
        },
        // @Description 4대보험 취득일 삭제
        async DELETE_INSURANCE4_JOIN_DATE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.delete.insurance4JoinDate(payload)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_INSURANCE4_JOIN_DATE error', error)
            }
        },
        // @Description 4대보험 상실일 삭제
        async DELETE_INSURANCE4_LOSS_DATE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.delete.insurance4LossDate(payload)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_INSURANCE4_LOSS_DATE error', error)
            }
        },
        // @Description 종사자 월보수변경신고 리스트 조회
        async MONTHLY_CHANGE_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.monthlyChangeReport(payload)
                console.log('MONTHLY_CHANGE_REPORT info', res)
                if (res.data.status === 200) {
                    commit('MONTHLY_CHANGE_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MONTHLY_CHANGE_REPORT', error)
            }
        },
        // @Description 종사자 월보수변경신고 요청조회
        async MONTHLY_CHANGE_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.monthlyChangeReportOne(payload)
                console.log('MONTHLY_CHANGE_APPLY info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('MONTHLY_CHANGE_APPLY', error)
            }
        },
        // @Description 종사자 월보수변경신고 요청,저장
        async SUBMIT_MONTHLY_CHANGE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.monthlyChangeReport(payload)
                console.log('SUBMIT_MONTHLY_CHANGE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SUBMIT_MONTHLY_CHANGE', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SUBMIT_MONTHLY_CHANGE', error)
            }
        },
        // @Description 장기근속수당 내역보기
        async SHOW_PAYSLIP_LONGWORK_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payslipLongworkDetail(payload)
                console.log('SHOW_PAYSLIP_LONGWORK_DETAIL info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SHOW_PAYSLIP_LONGWORK_DETAIL', error)
            }
        },
        // @Description 중증가산수당 내역보기
        async SHOW_PAYSLIP_SERIOUSADD_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payslipSeriousaddDetail(payload)
                console.log('SHOW_PAYSLIP_SERIOUSADD_DETAIL info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SHOW_PAYSLIP_SERIOUSADD_DETAIL', error)
            }
        },
        // @Description 원거리교통비 내역보기
        async SHOW_PAYSLIP_LONGDISTANCE_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payslipLongdistDetail(payload)
                console.log('SHOW_PAYSLIP_LONGDISTANCE_DETAIL info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SHOW_PAYSLIP_LONGDISTANCE_DETAIL', error)
            }
        },
        // @Description 간호가산수당 내역보기
        async SHOW_PAYSLIP_NURSEADD_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.payslipNurseaddDetail(payload)
                console.log('SHOW_PAYSLIP_NURSEADD_DETAIL info', res)
                if (res.data.status === 200) {
                    // store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SHOW_PAYSLIP_NURSEADD_DETAIL', error)
            }
        },
        // @Description 종사자 근로시간 생성
        async SET_WORK_HOUR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await sync.post.staffWorkHour(payload)
                console.log('SET_WORK_HOUR info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SET_WORK_HOUR', error)
            }
        },
        // @Description 종사자급여 초기화
        async DELETE_STAFF_PAYSLIP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.deleteStaffPayslip(payload)
                console.log('DELETE_STAFF_PAYSLIP info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_STAFF_PAYSLIP', error)
            }
        },
        // @Description 종사자급여 생성
        async CALCULATE_SALARY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await sync.post.syncCalculateSalary(payload)
                console.log('CALCULATE_SALARY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CALCULATE_SALARY', error)
            }
        },
        // @Description 종사자급여, 수급자 본부금 생성 전 에러내역 체크
        async PRE_ERROR_CHECK({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.errorCheck(payload)
                console.log('PRE_ERROR_CHECK info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('PRE_ERROR_CHECK', error)
            }
        },
        // @Description 종사자 급여 개별삭제
        async A_DELETE_STAFF_PAYSLIP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.deleteStaffPayslip(payload)
                console.log('A_DELETE_STAFF_PAYSLIP info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('A_DELETE_STAFF_PAYSLIP', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('A_DELETE_STAFF_PAYSLIP', error)
            }
        },
        // @Description 종사자 급여 정보 수정 후 저장
        async UPDATE_PERSONAL_PAYSLIP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.payslipCloseUpd(payload)
                console.log('UPDATE_PERSONAL_PAYSLIP info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_PERSONAL_PAYSLIP', error)
            }
        },
        // @Description 종사자 급여 일괄수정 조회
        async GET_BETCH_UPDATE_PAYSLIP_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.salarySixtyAll(payload)
                console.log('GET_BETCH_UPDATE_PAYSLIP_LIST info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_BETCH_UPDATE_PAYSLIP_LIST', error)
            }
        },
        // @Description 종사자 급여 일괄수정 등록
        async UPDATE_BETCH_UPDATE_PAYSLIP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.salarySixtyAll(payload)
                console.log('UPDATE_BETCH_UPDATE_PAYSLIP info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_BETCH_UPDATE_PAYSLIP', error)
            }
        },
        // @Description 장기근속수당 기관부담금 제외 금액 가져오기
        async GET_TEMP_LONGWORK_ALLOWANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.payslipLongworkTempget(payload)
                console.log('GET_TEMP_LONGWORK_ALLOWANCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_TEMP_LONGWORK_ALLOWANCE', error)
            }
        },
        // @Description 중증가산수당 기관부담금 제외 금액 가져오기
        async GET_TEMP_SERIOUSADD_ALLOWANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.payslipSeriousaddTempget(payload)
                console.log('GET_TEMP_SERIOUSADD_ALLOWANCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_TEMP_SERIOUSADD_ALLOWANCE', error)
            }
        },
        // @Description 원거리교통수당 기관부담금 제외 금액 가져오기
        async GET_TEMP_LONGDIST_ALLOWANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.payslipLongdistTempget(payload)
                console.log('GET_TEMP_LONGDIST_ALLOWANCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_TEMP_LONGDIST_ALLOWANCE', error)
            }
        },
        // @Description 간호가산수당 기관부담금 제외 금액 가져오기
        async GET_TEMP_NURSEADD_ALLOWANCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.payslipNurseaddTempget(payload)
                console.log('GET_TEMP_NURSEADD_ALLOWANCE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_TEMP_NURSEADD_ALLOWANCE', error)
            }
        },
        // @Description 종사자 장기근속수당 가져오기
        async SYNC_MINISTRY({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.post.syncMinistry(payload)
                console.log('SYNC_MINISTRY info', res)
                if(res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNC_MINISTRY error', error)
            }
        },
        // @Description 종사자 건강검진서 삭제(년간건강검진관리에서 사용)
        async DELETE_HEALTH_FILE({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await common.delete.fileDeleteAsync(payload)
                console.log('DELETE_HEALTH_FILE info', res)
                if(res.data.status === 201) {
                    // store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_HEALTH_FILE error', error)
            }
        },
        // @Description 임직원 상담일지 연간 현황 조회
        async STAFF_COUNSEL_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCounselYearly(payload)
                if (res.data.status === 200) {
                    commit('STAFF_COUNSEL_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COUNSEL_LIST error', error)
            }
        },
        // @Description 임직원 상담일지 월간 목록 조회
        async STAFF_COUNSEL_MONTHLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCounselMonthly(payload)
                if (res.data.status === 200) {
                    commit('STAFF_COUNSEL_MONTHLY_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COUNSEL_MONTHLY error', error)
            }
        },
        // @Description 임직원 상담일지 상세 조회 (1명 목록)
        async STAFF_COUNSEL_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCounsel(payload)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COUNSEL_DETAIL error', error)
            }
        },
        // @Description 임직원 상담일지 1건 조회
        async STAFF_COUNSEL_ONE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCounsel(payload)
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COUNSEL_ONE error', error)
            }
        },
        // @Description 임직원 상담일지 등록
        async REGIST_STAFF_COUNSEL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                const sanitized = sanitizeCounselPayload(payload, 'post')
                res = await employee.post.staffCounsel(sanitized)
                if (res.data.status === 201) {
                    // 성공 메시지는 컴포넌트 DialogNoticeResult에서 표시
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_STAFF_COUNSEL error', error)
            }
        },
        // @Description 임직원 상담일지 수정
        async UPDATE_STAFF_COUNSEL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                const sanitized = sanitizeCounselPayload(payload, 'put')
                res = await employee.put.staffCounsel(sanitized)
                if (res.data.status === 201 || res.data.status === 200) {
                    // 성공 메시지는 컴포넌트 DialogNoticeResult에서 표시
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_STAFF_COUNSEL error', error)
            }
        },
        // @Description 임직원 상담일지 삭제
        async DELETE_STAFF_COUNSEL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.delete.staffCounsel(payload)
                if (res.data.status === 201 || res.data.status === 200) {
                    // 성공 메시지는 컴포넌트 DialogNoticeResult에서 표시
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_STAFF_COUNSEL error', error)
            }
        },
        // @Description 임직원 상담 이력 (스냅샷) 조회
        async STAFF_COUNSEL_HISTORY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCounselHistory(payload)
                if (res.data.status === 200) {
                    commit('STAFF_COUNSEL_HISTORY', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COUNSEL_HISTORY error', error)
            }
        },
        // @Description 임직원 상담일지 첨부파일 목록 조회
        async STAFF_COUNSEL_FILES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.get.staffCounselFiles(payload)
                if (res.data.status === 200) {
                    commit('STAFF_COUNSEL_FILES', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('STAFF_COUNSEL_FILES error', error)
            }
        },
        // @Description 임직원 상담일지 첨부파일 개별 삭제
        async DELETE_STAFF_COUNSEL_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await employee.delete.staffCounselFile(payload)
                if (res.data.status !== 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_STAFF_COUNSEL_FILE error', error)
            }
        },
    },
    getters: {
        STAFFS: state => {
            let arr = null
            state.copiedStaffs = []
            if (!state.staffs) return

            if (state.contractCode === '11')
                arr = state.staffs.filter(item => item.staffContractCode === '21' || item.staffContractCode === '22')
            else if (state.contractCode === '12')
                arr = state.staffs.filter(item => item.staffContractCode === '23' || item.staffContractCode === '25')
            else
                arr = state.staffs

            if (state.state)
                arr = arr.filter(item => item.contractStateCode === state.state)
            else
                arr = arr

            if (state.searchWord) {
                if (pattern.test(state.searchWord)) {
                    arr = arr.filter(item => {
                        if (item.mobileNo) return item.mobileNo.includes(state.searchWord.clearValue())
                    })
                } else {
                    arr = arr.filter(item => item.userName.includes(state.searchWord))
                }
            }


            return state.copiedStaffs = arr

            // not be used from 2022.01.04
            // if(state.state) {
            //     arr = state.staffs.filter(item => 
            //         item.contractStateCode === state.state    
            //     )
            //     if(state.contractCode === '11') {
            //         arr = arr.filter(item => item.staffContractCode === '21'||item.staffContractCode === '22')
            //     } else if(state.contractCode === '12') {
            //         arr = arr.filter(item => item.staffContractCode !== '21'&&item.staffContractCode !== '22')
            //     }
            // } else {
            //     if(state.contractCode === '11') {
            //         arr = state.staffs.filter(item => item.staffContractCode === '21'||item.staffContractCode === '22')
            //     } else if(state.contractCode === '12') {
            //         arr = state.staffs.filter(item => item.staffContractCode !== '21'&&item.staffContractCode !== '22')
            //     } else {
            //         arr = state.staffs
            //     }
            // }

            // if(state.searchWord) {
            //     if(pattern.test(state.searchWord)) {
            //         return state.copiedStaffs = arr.filter(item => {
            //             if(item.mobileNo) return item.mobileNo.includes(state.searchWord.clearValue())
            //         })
            //     } else {
            //         return state.copiedStaffs = arr.filter(item => item.userName.includes(state.searchWord))
            //     }
            // } else {
            //     state.copiedStaffs = arr
            //     return arr
            // }
        },
        SELECTED_IDX: state => { //userIdx
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.userIdx)
                })
            }
            return arr
        },
        SELECTED_SCIDX: state => { //staffContractIdx
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.staffContractIdx)
                })
            }
            return arr
        },
        SELECTED_CWIDX: state => { //contractWorkIdxs
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.contractWorkIdx)
                })
            }
            return arr
        },
        SELECTED_SBIDX: state => { //staffBaseIdx
            let arr = []
            if (state.selected && state.selected.length) {
                state.selected.forEach(item => {
                    arr.push(item.staffBaseIdx)
                })
            }
            return arr
        },
        BANK_INFO: state => {
            if (state.bankInfo) {
                return state.bankInfo
            } else {
                return {
                    depositorName: null,
                    depositBankCode: null,
                    userBankAccountIdx: 0,
                    accountNo: null
                }
            }
        },
        BRANCH_OFFICE_SEAL: state => {
            return (state.branchInfoDetail && state.branchInfoDetail.officeSealFileIdx) ?
                URLs.display + '/' + state.branchInfoDetail.officeSealFileIdx :
                null
        },
        CONTRACT_SALARY_INFO: state => {
            if (state.contractInfoDetail) {
                console.log("salary info on vuex", state.contractInfoDetail, state.customerSalarySetting)
                if (state.contractInfoDetail.staffContractCode === '23' ||
                    state.contractInfoDetail.staffContractCode === '25') {
                    return state.salaryNumberList
                } else {
                    return (state.salaryNumberList) ? state.salaryNumberList[0] : null
                }
            }
        },
        PAYROLL_LIST: state => {
            console.log("payroll check ", state.payrollList)
            if (state.payrollList) {

                let copy, paste = []

                state.payrollList.forEach((element) => {
                    if (!element.payslipList) {
                        copy = {
                            actualSalaryAmount: 0,
                            addAllowance: 0,
                            annualAllowance: 0,
                            b3AddCount: 0,
                            b3DementiaCount: 0,
                            b3000Count: 0,
                            b3003Count: 0,
                            b3006Count: 0,
                            baseSalarySum: 0,
                            bathAllowance: 0,
                            businessAllowance: 0,
                            carManageAllowance: 0,
                            careOvertimeCount: 0,
                            cognitiveActivityAllowance: 0,
                            companyComwelAdjust: 0,
                            companyComwelFee: 0,
                            companyEmpinsAdjust: 0,
                            companyEmpinsFee: 0,
                            companyEsvcdAdjust: 0,
                            companyEsvcdFee: 0,
                            companyLtcareAdjust: 0,
                            companyLtcareFee: 0,
                            companyNhisAdjust: 0,
                            companyNhisFee: 0,
                            companyNpsAdjust: 0,
                            companyNpsFee: 0,
                            customerBranchIdx: 0,
                            deduct4InsureAdjust: 0,
                            deductCompanyTotal: 0,
                            deductCopay: 0,
                            deductCoworkerFee: 0,
                            deductEmpinsAdjust: 0,
                            deductEmpinsFee: 0,
                            deductEtc: 0,
                            deductIncomeTax: 0,
                            deductLongWorkAllowance: 0,
                            deductLtcareAdjust: 0,
                            deductLtcareFee: 0,
                            deductNhisAdjust: 0,
                            deductNhisFee: 0,
                            deductNpsAdjust: 0,
                            deductNpsFee: 0,
                            deductResidenceTax: 0,
                            deductTotal: 0,
                            dutyAllowance: 0,
                            excessOtherAllowance: 0,
                            extraAllowance: 0,
                            familyCareAllowance: 0,
                            grade5Count: 0,
                            grade5SalarySum: 0,
                            incentiveAllowance: 0,
                            incomeTotal: 0,
                            longWorkAllowance: 0,
                            mealAllowance: 0,
                            nonTaxIncome: 0,
                            nurseHour: 0,
                            otherAllowance: 0,
                            overtimeAllowance: 0,
                            payYm: 0,
                            preMonthOmission: 0,
                            premiumAllowance: 0,
                            resignReserveAllowance: 0,
                            salaryYear: 0,
                            salaryYm: 0,
                            severancePay: 0,
                            staffAccountNo: 0,
                            staffBankName: 0,
                            staffContractIdx: 0,
                            staffDepositorName: 0,
                            staffPayslipMonthSpecIdx: 0,
                            taxIncome: 0,
                            treatImproveAllowance: 0,
                            weeklyAllowance: 0,
                            workingAllowance: 0,
                            // add
                            bathHour: element.bathHour,
                            careHour: element.careHour,
                            hourSum: element.hourSum,
                            familyHour: element.familyHour,
                            payAmount: element.payAmount,
                            payAmountSum: element.payAmountSum,
                        }
                    } else {
                        copy = element.payslipList[0]
                    }
                    paste.push({
                        ...copy,
                        bathHour: element.bathHour,
                        careHour: element.careHour,
                        hourSum: element.hourSum,
                        familyHour: element.familyHour,
                        payAmount: element.payAmount,
                        payAmountSum: element.payAmountSum,
                        birthday: element.birthday,
                        mobileNo: element.mobileNo,
                        staffBaseIdx: element.staffBaseIdx,
                        userIdx: element.userIdx,
                        userName: element.userName,
                    })

                    // console.log("for each confirm", element.payslipList)
                })
                return paste

            } else {
                return state.payrollList
            }
        },
        OFFICE_SEAL_URL: state => {
            return state.contractOfficeSeal ? URLs.display + '/' + state.contractOfficeSeal : null
        },
        STAFF_SIGN_URL: state => {
            return state.contractStaffSign ? URLs.display + '/' + state.contractStaffSign : null
        },
        CEO_SIGN_URL: state => {
            return state.contractCeoSign ? URLs.display + '/' + state.contractCeoSign : null
        },
        GET_LONG_PERIOD_WORKING_STAFFS: state => {
            return state.longPeriodWorkingStaffs ? state.longPeriodWorkingStaffs : []
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/employees.js